import { clientConfig } from '@/config/clientConfig';

// TODO remove graphqlUrl, and create newone
// Extract origin from existing ENV variable
const graphqlUrl = clientConfig.api.graphqlUrl;
const graphqlDirectUrl = clientConfig.api.directGraphqlUrl;

const objUrl = new URL(graphqlUrl);
const objDirectUrl = new URL(clientConfig.isExported ? graphqlUrl : graphqlDirectUrl);
const url = `${objUrl.origin}`;

// Public-facing gateway origin
const gtwUrl = clientConfig.api.gtwUrl;

export const apiConfig = {
  url: url,
  directUrl: objDirectUrl.origin,
  gtwUrl,
};
